import '../css/resources.scss';
import {render} from 'preact';
import {createSearchContext} from '@ultradent/upi-fuzzy-search';
import {Distributors} from './containers/Resources/Distributors/index';
import {ProductInstructions} from './containers/Resources/ProductInstructions/index';
import {productDocumentationRoutes} from './containers/Resources/ProductDocumentation/index';
import SlideMenu from '@modules/ui/slide-menu';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';

$( document ).ready( async function () {

    var sdsFilter = $( '#sdsFilter' );
    var sdsList = $( '#sds-resource-list' );

    const distList = document.getElementById( 'distributor-resource-list' );
    const ifuList = document.getElementById( 'product-instructions-list-container' );
    const documentationList = document.getElementById( 'product-documentation-list-container' );
    const slideMenuEl = $( '.js-slideMenu' );

    if ( distList ) {
        render( <Distributors/>, distList );
    }
    if ( ifuList ) {
        render( <ProductInstructions/>, ifuList );
    }
    if ( documentationList ) {
        render( <RouterProvider router={createBrowserRouter( productDocumentationRoutes )}/>, documentationList );
    }
    if ( slideMenuEl ) {
        const slideMenu = new SlideMenu( slideMenuEl );
    }

    // if sdsFilter present then create an indexed list of the resource list
    if ( sdsFilter ) {
        const resourceIndex = sdsList.find( 'li' ).map( ( i, item ) => {
            const $item = $( item );
            return {
                title: $item.text().trim(),
                href: $item.find( 'a' ).attr( 'href' ),
                node: $item
            };
        } );

        const
            sdsContext = createSearchContext( resourceIndex, ['title'] ),
            renderer = createSDSRenderer( sdsContext );

        // update list based on defualt input value
        if ( sdsFilter.val() ) {
            renderer( sdsFilter.val() );
        }

        sdsFilter.on( 'input', e => {
            renderer( e.target.value );
        } )
    }

    /**
     * HOC that returns a functoin that accepts a query to be executed in a given
     * search context provided from upi-fuzzy-search
     * @param  {upi-fuzzy-search} srchContext search context to execute query from
     * @return {Function(String)} HOC to execute query
     */
    function createSDSRenderer ( srchContext ) {
        return query => {
            const {results} = srchContext.query( query.trim() );
            sdsList.html( buildSDSList( results ) );
        }
    }

    function buildSDSList ( items ) {
        return items.map( item => {
            return item.node;
        } )
    }

    //Social Sharing Links
    setShareLinks();

    function socialWindow ( url ) {
        var params = '';
        window.open( url, 'NewWindow', params );
    }

    function setShareLinks () {
        var pageUrl = encodeURIComponent( document.URL );
        var emailLink = document.URL;
        var tweet = encodeURIComponent( jQuery( 'meta[property=\'og:description\']' ).attr( 'content' ) );

        jQuery( '.social-share.facebook' ).on( 'click', function () {
            var url = 'https://www.facebook.com/sharer.php?u=' + pageUrl;
            socialWindow( url );
        } );

        jQuery( '.social-share.twitter' ).on( 'click', function () {
            var url = 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + tweet;
            socialWindow( url );
        } );

        jQuery( '.social-share.linkedin' ).on( 'click', function () {
            var url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl;
            socialWindow( url );
        } )

        jQuery( '.social-share.email' ).on( 'click', function () {
            var url = 'mailto:?subject=I think you\'ll like this article from Ultradent!&body=Take a look at this article from Ultradent.com and let me know what you think! Feel free to share it with other dental professionals, or anyone else you think will find it of interest.' +
                emailLink;
            socialWindow( url );
        } )
    }

} );
